import angular from 'angular';
import gridHeight from '../../core/shared-service/grid-utils';

class DocrepoInvoiceDetailCtrl {
    /*@ngInject*/
    constructor(uiGridConstants) {
        this.uiGridConstants = uiGridConstants;
    }

    $onInit() {
        let vm = this;
        vm.getAttachmentGridHeight = getAttachmentGridHeight;

        vm.attachmentGridOptions = {
            columnDefs: [
                { name: 'attachmentId', displayName: 'commons.technical_id', headerCellFilter: 'translate' },
                {
                    name: 'typeDoc',
                    displayName: 'commons.type',
                    headerCellFilter: 'translate',
                    sort: { direction: 'desc', priority: 0 }
                },
                { name: 'fileName', displayName: 'commons.file_name', headerCellFilter: 'translate' }
            ],
            exporterOlderExcelCompatibility: true,
            enableSorting: true,
            onRegisterApi: onRegisterAttachmentApi,
            enableGridMenu: false,
            enableColumnMenus: false,
            enableVerticalScrollbar: vm.uiGridConstants.scrollbars.NEVER
        };

        // Grille
        function onRegisterAttachmentApi(attachmentGridApi) {
            vm.attachmentGridApi = attachmentGridApi;
        }

        function getAttachmentGridHeight() {
            return gridHeight(vm.attachmentGridApi);
        }

        if (vm.invoice) {
            vm.attachmentGridOptions.data = vm.invoice.attachmentItems;
            vm.attachmentGridOptions.totalItems = vm.invoice.attachmentItems.length;
        }
    }
}

angular.module('app.docrepo_invoice').component('docrepoInvoiceDetail', {
    templateUrl: require('./detail.html'),
    controller: DocrepoInvoiceDetailCtrl,
    bindings: {
        invoice: '<' // Invoice
    }
});
